// env
export const API_BANNER_BASE_URL: string = process.env.API_BANNER_BASE_URL || ''
export const MS_BASE_PATH = process.env.MICROSERVICE_DOMAIN
// main job search
export const NEW_RIGHT_BANNER_POSITION = 15
export const MIDDLE_BANNER_POSITION = 21
export const JOB_ALERT_REMINDER_POSITION = 50

// side job search
export const STAND_ALONE_BANNER_POSITION = 5

// sorting index name
export const SORT_DEFAULT_INDEX = process.env.SORT_DEFAULT_INDEX || process.env.ALGOLIA_DEFAULT_INDEX
export const SORT_RELEVANCE_INDEX = process.env.SORT_RELEVANCE_INDEX || process.env.ALGOLIA_ELEVANCE_INDEX
export const SORT_SALARY_INDEX = process.env.SORT_SALARY_INDEX || process.env.ALGOLIA_SALARY_INDEX
export const SORT_POSTED_LATEST_INDEX = process.env.SORT_POSTED_LATEST_INDEX || process.env.ALGOLIA_POSTED_LATEST_INDEX
export const SORT_POSTED_OLDEST_INDEX = process.env.SORT_POSTED_OLDEST_INDEX || process.env.ALGOLIA_POSTED_OLDEST_INDEX

export const MANAGEMENT_JOB_DEFAULT = 'MANAGEMENT_JOB_DEFAULT'
export const MANAGEMENT_JOB_BY_DATE = 'MANAGEMENT_JOB_BY_DATE '
export const MANAGEMENT_JOB_BY_SALARY = 'MANAGEMENT_JOB_BY_SALARY '

// job alert remider
export const NUMBER_DAY_OF_IGNORE = 3
export const DEFAULT_MAX_JOB_ALERT = 10

// hr insider
export enum EJobLevel {
    FRESHER = 1,
    ENTRY = 8
}

// adr turbo
export const ADR1_SETTING = 'ADR1_SETTING'
export const ADR2_SETTING = 'ADR2_SETTING'

export const emptyResponse = {
    data: null
}

export const DEFAULT_SALARY = 1000
export const APPEAR_SORT_RELEVANT_TOOLTIP_TRACK_KEY = 'sr:appear_sort_relevant_tooltip_tracked'
export const QUICK_SALARY_FILTER_TOOLTIP_IMPRESSION_TRACK_KEY = 'sr:quick_salary_filter_tooltip_impression_tracked'
export const PREFERRED_SORT_STORAGE_KEY = 'VNWSearchJob[preferredSortIndexName]'
